import React from 'react';
import { Box, ToggleButtonGroup, ToggleButton } from '@mui/material';
import { useLanguage } from '../../contexts/LanguageContext';

const LanguageSwitch = () => {
  const { language, setLanguage } = useLanguage();

  const handleLanguageChange = (e, newLang) => {
    if (newLang !== null) {
      console.log('Changing language to:', newLang); // Для отладки
      setLanguage(newLang);
    }
  };

  return (
    <Box sx={{ 
      position: 'fixed',
      bottom: 20,
      right: 20,
      zIndex: 1000
    }}>
      <ToggleButtonGroup
        value={language}
        exclusive
        onChange={handleLanguageChange}
        size="small"
        sx={{
          backgroundColor: 'white',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          borderRadius: '12px',
          padding: '4px',
          '& .MuiToggleButton-root': {
            border: 'none',
            borderRadius: '8px !important',
            px: 2,
            py: 0.7,
            textTransform: 'none',
            fontSize: '0.875rem',
            fontWeight: 500,
            color: '#666',
            '&:hover': {
              backgroundColor: 'rgba(0,0,0,0.04)'
            },
            '&.Mui-selected': {
              backgroundColor: '#000',
              color: 'white',
              '&:hover': {
                backgroundColor: '#333'
              }
            }
          }
        }}
      >
        <ToggleButton value="kz">Қаз</ToggleButton>
        <ToggleButton value="ru">Рус</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default LanguageSwitch; 